import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { EXPORT, UPLOAD } from '@hobs/constants/catalog';

export function exportCatalog() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('catalogItems/excel', { forceBlob: true })
      .then(response => {
        if (response) {
          dispatch(success());
          return { success: true, blob: response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EXPORT.REQUEST };
  }
  function success() {
    return { type: EXPORT.SUCCESS };
  }
  function failure(error) {
    return { type: EXPORT.FAILURE, error };
  }
}

export function uploadCatalog(body) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('catalogItems/excel', {
      body: body,
      method: 'POST',
      multipart: true
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPLOAD.REQUEST };
  }
  function success() {
    return { type: UPLOAD.SUCCESS };
  }
  function failure(error) {
    return { type: UPLOAD.FAILURE, error };
  }
}